module.exports = __webpack_public_path__ + "static/media/doctor4-150.34810d6b.webp";